<ng-otp-input
  (onInputChange)="onOtpChange($event)"
  [config]="config"></ng-otp-input>
